import { rem } from 'polished';
import styled from 'styled-components';
import { TitleWithBenefitsStyled } from '../TitleWithBenefitsStyled';

export const TitleWithBenefitsStyledAC = styled(TitleWithBenefitsStyled)`
    .title {
        font-size: ${rem(40)};
        color: ${({ theme }) => theme.colors.grey5};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        text-transform: uppercase;
    }
    .specs .specs-title {
        font-size: ${rem(18)};
        color: ${({ theme }) => theme.colors.grey5};
        font-weight: ${({ theme }) => theme.fontWeights.textLight};
    }
    .benefits {
        padding-left: 0;
        background: none;
        .bullet-points.allow-bullet-points {
            padding-left: ${rem('16px')};
            .offer > div:first-child {
                max-width: 98%;
            }
            .offer svg {
                circle {
                    fill: ${({ theme }) => theme.colors.grey5};
                    stroke: ${({ theme }) => theme.colors.grey5};
                }

                line {
                    stroke: ${({ theme }) => theme.colors.white};
                    stroke-width: ${rem('3px')};
                }
            }
        }
        .heading {
            color: ${({ theme }) => theme.colors.grey27};
        }
        .bullet-points {
            margin: 0;
        }
    }
`;
